import React from "react";
import { IonRefresher, IonRefresherContent, RefresherEventDetail } from "@ionic/react";
import "./refreshComponentStyle.css";

interface IRefresComponentProps {
    onRefreshComponent:()=>void;
}
const RefreshComponent: React.FC<IRefresComponentProps> = ({onRefreshComponent}) => {
   
    function handleRefresh(event: CustomEvent<RefresherEventDetail>) {
        setTimeout(() => {
            onRefreshComponent();
            // Any calls to load data go here
            event.detail.complete();
        }, 2000);
    }

    return (
        <IonRefresher
            slot="fixed"
            onIonRefresh={handleRefresh}
        >
            <IonRefresherContent></IonRefresherContent>
        </IonRefresher>
    );
};

export default RefreshComponent;
